// Document type mapping between API format and StaticFieldCode enum format
export const DOCUMENT_TYPE_MAPPING = {
  // API response format (snake_case) to StaticFieldCode enum format (camelCase)
  passport_copy: 'passportCopy',
  visa_page: 'visaPage',
  photo: 'photo',
  shinasnama: 'shinasnama',
  labour_contract: 'labourContract',
  salary_certificate: 'salaryCertificate',
  birth_certificate: 'birthCertificate',
  emirates_id: 'emiratesId',
  emirates_id_copy: 'emiratesIdCopy',
  ohc: 'ohc',
  driving_license: 'drivingLicense',
  resume: 'resume',
  educational_certificate: 'educationalCertificate',
  experience_certificate: 'experienceCertificate',
  police_clearance_certificate: 'policeClearanceCertificate',

  // StaticFieldCode enum format (camelCase) to API request format (snake_case)
  passportCopy: 'passport_copy',
  visaPage: 'visa_page',
  photo: 'photo',
  shinasnama: 'shinasnama',
  labourContract: 'labour_contract',
  salaryCertificate: 'salary_certificate',
  birthCertificate: 'birth_certificate',
  emiratesId: 'emirates_id',
  emiratesIdCopy: 'emirates_id_copy',
  ohc: 'ohc',
  drivingLicense: 'driving_license',
  educationalCertificate: 'educational_certificate',
  experienceCertificate: 'experience_certificate',
  policeClearanceCertificate: 'police_clearance_certificate',

  // Organization document type mappings
  trade_license: 'tradeLicenseCopy',
  memo_of_association: 'memoOfAssociation',
  article_of_association: 'articleOfAssociation',
  establishment_card: 'establishmentCardCopy',
  immigration_card: 'immigrationCardCopy',
  chamber_certificate: 'chamberCertificateCopy',
  vat_certificate: 'vatCertificateCopy',
  trn_certificate: 'trnCertificateCopy',
  share_capital_certificate: 'shareCapitalCertificate',
  power_of_attorney: 'powerOfAttorney',
  board_resolution: 'boardResolution',
  audited_financials: 'auditedFinancials',

  // Reverse mappings (camelCase to snake_case)
  tradeLicenseCopy: 'trade_license',
  memoOfAssociation: 'memo_of_association',
  articleOfAssociation: 'article_of_association',
  establishmentCardCopy: 'establishment_card',
  immigrationCardCopy: 'immigration_card',
  chamberCertificateCopy: 'chamber_certificate',
  vatCertificateCopy: 'vat_certificate',
  trnCertificateCopy: 'trn_certificate',
  shareCapitalCertificate: 'share_capital_certificate',
  powerOfAttorney: 'power_of_attorney',
  boardResolution: 'board_resolution',
  auditedFinancials: 'audited_financials'
};

export const STAT_FIELDS = {
  uid: {
    label: "UID",
    type: "TEXT"
  },
  firstNameEn: {
    label: "First Name (English)",
    type: "TEXT"
  },
  middleNameEn: {
    label: "Middile Name (English)",
    type: "TEXT"
  },
  lastNameEn: {
    label: "Last Name (English)",
    type: "TEXT"
  },
  firstNameAr: {
    label: "First Name (Arabic)",
    type: "TEXT"
  },
  middleNameAr: {
    label: "Middle Name (Arabic)",
    type: "TEXT"
  },
  lastNameAr: {
    label: "Last Name (Arabic)",
    type: "TEXT"
  },
  nameEn: {
    label: "Name (English)",
    type: "TEXT"
  },
  nameAr: {
    label: "Name (Arabic)",
    type: "TEXT"
  },
  dob: {
    label: "Date Of Birth",
    type: "DATE"
  },
  gender: {
    label: "Gender",
    type: "SELECT"
  },
  nationality: {
    label: "Nationality",
    type: "TEXT"
  },
  passportNumber: {
    label: "Passport Number",
    type: "TEXT"
  },
  passportIssue: {
    label: "Passport Issue",
    type: "DATE"
  },
  passportExpiry: {
    label: "Passport Expiry",
    type: "DATE"
  },
  passportIssuePlaceEn: {
    label: "Passport Issue Place (English)",
    type: "TEXT"
  },
  passportIssuePlaceAr: {
    label: "Passport Issue Place (Arabic)",
    type: "TEXT"
  },
  emiratesId: {
    label: "Emirates Id",
    type: "TEXT"
  },
  emiratesIdIssueDate: {
    label: "Emirates Id Issue Date",
    type: "DATE"
  },
  emiratesIdExpiryDate: {
    label: "Emirates Id Expiry Date",
    type: "DATE"
  },
  emiratesIdCopy: {
    label: "Emirates Id Copy",
    type: "FILE"
  },
  birthPlaceEn: {
    label: "Birth Place (English)",
    type: "TEXT"
  },
  birthPlaceAr: {
    label: "Birth Place (Arabic)",
    type: "TEXT"
  },
  birthCertificate: {
    label: "Birth Certificate",
    type: "FILE"
  },
  emirate: {
    label: "Emirate",
    type: "TEXT"
  },
  address: {
    label: "Address",
    type: "TEXT"
  },
  area: {
    label: "Area",
    type: "TEXT"
  },
  buildingNumber: {
    label: "Building Number",
    type: "TEXT"
  },
  poBox: {
    label: "PO Box",
    type: "TEXT"
  },
  mobileNumber: {
    label: "Mobile Number",
    type: "PHONE"
  },
  landNumber: {
    label: "Land Number",
    type: "PHONE"
  },
  deliveryNumber: {
    label: "Delivery Number",
    type: "PHONE"
  },
  email: {
    label: "Email",
    type: "EMAIL"
  },
  fileNumber: {
    label: "File Number",
    type: "TEXT"
  },
  passportCopy: {
    label: "Passport Copy",
    type: "FILE"
  },
  visaPage: {
    label: "Visa Page",
    type: "FILE"
  },
  photo: {
    label: "Photo",
    type: "FILE"
  },
  shinasnama: {
    label: "Shinsnama",
    type: "FILE"
  },
  labourContract: {
    label: "Labour Contract",
    type: "FILE"
  },
  salaryCertificate: {
    label: "Salary Certificate",
    type: "FILE"
  },
  resume: {
    label: "Resume / CV",
    type: "FILE"
  },
  educationalCertificate: {
    label: "Educational Certificate",
    type: "FILE"
  },
  experienceCertificate: {
    label: "Experience Certificate",
    type: "FILE"
  },
  policeClearanceCertificate: {
    label: "Police Clearance Certificate",
    type: "FILE"
  },
  ohc: {
    label: "OHC",
    type: "FILE"
  },
  drivingLicense: {
    label: "Driving License",
    type: "FILE"
  },
  biometricLocation: {
    label: "Biometric Location",
    type: "TEXT"
  },
  medicalLocation: {
    label: "Medical Location",
    type: "SELECT"
  },
  ohhLocation: {
    label: "Ohh Location",
    type: "TEXT"
  },
  contactPerson: {
    label: "Contact Person",
    type: "PERSON"
  },

  // --- Organization Fields ---
  // Company info
  companyNameEn: {
    label: "Company Name (English)",
    type: "TEXT"
  },
  companyNameAr: {
    label: "Company Name (Arabic)",
    type: "TEXT"
  },
  legalForm: {
    label: "Legal Form",
    type: "TEXT"
  },
  establishmentDate: {
    label: "Establishment Date",
    type: "DATE"
  },

  // License info
  licenseNumber: {
    label: "License Number",
    type: "TEXT"
  },
  licenseIssueDate: {
    label: "License Issue Date",
    type: "DATE"
  },
  licenseExpiryDate: {
    label: "License Expiry Date",
    type: "DATE"
  },
  licenseAuthority: {
    label: "License Authority",
    type: "TEXT"
  },
  commercialRegistration: {
    label: "Commercial Registration",
    type: "TEXT"
  },

  // Government cards
  establishmentCardNumber: {
    label: "Establishment Card Number",
    type: "TEXT"
  },
  establishmentCardExpiry: {
    label: "Establishment Card Expiry",
    type: "DATE"
  },
  immigrationCardNumber: {
    label: "Immigration Card Number",
    type: "TEXT"
  },
  immigrationCardExpiry: {
    label: "Immigration Card Expiry",
    type: "DATE"
  },
  mohreLicenseNumber: {
    label: "MOHRE License Number",
    type: "TEXT"
  },
  chamberMembershipNumber: {
    label: "Chamber Membership Number",
    type: "TEXT"
  },

  // Tax info
  trnNumber: {
    label: "TRN Number",
    type: "TEXT"
  },
  vatRegistrationNumber: {
    label: "VAT Registration Number",
    type: "TEXT"
  },
  vatRegistrationDate: {
    label: "VAT Registration Date",
    type: "DATE"
  },
  corporateTaxRegistration: {
    label: "Corporate Tax Registration",
    type: "TEXT"
  },
  taxYear: {
    label: "Tax Year",
    type: "TEXT"
  },

  // Financial
  bankName: {
    label: "Bank Name",
    type: "TEXT"
  },
  accountNumber: {
    label: "Account Number",
    type: "TEXT"
  },
  iban: {
    label: "IBAN",
    type: "TEXT"
  },
  swiftCode: {
    label: "SWIFT Code",
    type: "TEXT"
  },

  // Signatory
  authSignatoryName: {
    label: "Authorized Signatory Name",
    type: "TEXT"
  },
  authSignatoryDesignation: {
    label: "Authorized Signatory Designation",
    type: "TEXT"
  },
  authSignatoryEmiratesId: {
    label: "Authorized Signatory Emirates ID",
    type: "TEXT"
  },
  authSignatoryMobile: {
    label: "Authorized Signatory Mobile",
    type: "PHONE"
  },
  authSignatoryEmail: {
    label: "Authorized Signatory Email",
    type: "EMAIL"
  },

  // Owner info
  ownerName: {
    label: "Owner Name",
    type: "TEXT"
  },
  ownerNationality: {
    label: "Owner Nationality",
    type: "TEXT"
  },
  ownerPassportNumber: {
    label: "Owner Passport Number",
    type: "TEXT"
  },
  ownerEmiratesId: {
    label: "Owner Emirates ID",
    type: "TEXT"
  },
  ownerSharePercentage: {
    label: "Owner Share Percentage",
    type: "TEXT"
  },

  // Org document files
  tradeLicenseCopy: {
    label: "Trade License Copy",
    type: "FILE"
  },
  memoOfAssociation: {
    label: "Memorandum of Association",
    type: "FILE"
  },
  articleOfAssociation: {
    label: "Article of Association",
    type: "FILE"
  },
  establishmentCardCopy: {
    label: "Establishment Card Copy",
    type: "FILE"
  },
  immigrationCardCopy: {
    label: "Immigration Card Copy",
    type: "FILE"
  },
  chamberCertificateCopy: {
    label: "Chamber Certificate Copy",
    type: "FILE"
  },
  vatCertificateCopy: {
    label: "VAT Certificate Copy",
    type: "FILE"
  },
  trnCertificateCopy: {
    label: "TRN Certificate Copy",
    type: "FILE"
  },
  shareCapitalCertificate: {
    label: "Share Capital Certificate",
    type: "FILE"
  },
  powerOfAttorney: {
    label: "Power of Attorney",
    type: "FILE"
  },
  boardResolution: {
    label: "Board Resolution",
    type: "FILE"
  },
  auditedFinancials: {
    label: "Audited Financials",
    type: "FILE"
  }
};

export const MEDICAL_LOCATIONS = [
  "Al Nahda Occupational Health Center",
  "Salem Abu Hail",
  "Salem, Al Muhaisnah Branch",
  "Salem ENOC",
  "Salem Center – JVC – Circle Mall",
  "Al Yalayis Fitness Medical Center - Jabal Ali Branch",
  "Al Muhaisnah Medical Fitness Center",
  "Zabeel Health Center (for Zabeel Residents)",
  "Al Lusaily Health Center",
  "Hatta Hospital",
  "Al Rashidiya Medical Fitness Center",
  "Al Yalayis Medical Fitness Center",
  "Dubai Airport Center",
  "Al Quoz Mall Medical Fitness Center",
  "Bur Dubai Medical Fitness Center",
  "Al Karama Medical Fitness Center",
  "Al Garhoud Medical Fitness Center",
  "Smart Salem – DIFC, Index Tower",
  "Smart Salem – TECOM, Dubai Knowledge Park",
  "Smart Salem – Al Wasl, City Walk"
];
